module.exports = __webpack_public_path__ + "img/secure-bg.f487eabb.svg";